import {
  BACKGROUND,
  BackgroundDefinition,
  BULLET_LIST,
  LayoutHalfPageDefinition,
  LayoutListDefinition,
  LAYOUT_HALF_PAGE,
  LAYOUT_LIST,
  TEXT
} from '../items';
import { Translator } from '../Translator';
import { ListHelper } from './itemHelpers/ListHelper';
import { translate } from './translate';

export const List3: Translator = sequence => {
  /*
    CAT-104: List3, List4: Elements switch places after user updates Items
  */

  // const isListOnTheRight: boolean =
  //   (
  //     sequence?.items?.filter(
  //       item => item.__typename === 'List'
  //     )[0] as unknown as { items: Array<{ title?: string }> }
  //   ).items
  //     .map(text => text.title as string)
  //     ?.sort((a: string, b: string) => b.length - a.length)[0].length < 50;

  const isListOnTheRight = true;

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'List':
        return {
          id: item.id,
          type: LAYOUT_HALF_PAGE,
          values: {
            side: isListOnTheRight ? 'right' : 'left'
          },
          items: [
            {
              id: `${item.id}.innerlist`,
              type: LAYOUT_LIST,
              values: {
                orientation: 'column',
                align: 'left'
              },
              items: [
                {
                  type: TEXT,
                  id: `${item.id}_subtitle`,
                  items: [],
                  values: {
                    value: item.subtitle,
                    variant: 'sub_heading',
                    icon: item?.icon || ''
                  }
                },
                {
                  type: TEXT,
                  id: `${item.id}_title`,
                  items: [],
                  values: {
                    value: item.title,
                    variant: 'heading1'
                  }
                },
                {
                  type: BULLET_LIST,
                  id: item.id,
                  values: [],
                  items: ListHelper({
                    items: item.items,
                    bulletType:
                      sequence.templateName === 'List3' ? 'default' : undefined
                  })
                }
              ]
            } as LayoutListDefinition
          ]
        } as LayoutHalfPageDefinition;
      default:
        return null;
    }
  });

  const bg = root.items.find(
    i => i.type === BACKGROUND
  ) as BackgroundDefinition;
  if (bg)
    bg.values.direction = {
      _: 'column-reverse',
      lg: isListOnTheRight ? 'row-reverse' : 'row'
    };

  return root;
};
